export default __webpack_public_path__ + "static/media/tpk-2024-buoy.2453f073.webp";